/**
 * AI 生文- 删除会话
 * @returns
 */
 import { deleteChat } from "@/services/api/thunks/chat";
import { useAppDispatch } from "@/store/hooks";
import { ChatTopic } from "@/types/writing";
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";


type Props = {
  isOpen: boolean;
  onClose: () => void;
  editInfo: ChatTopic;
};

const DelModal = (props: Props) => {
  const { isOpen, onClose, editInfo } = props;
  const dispatch = useAppDispatch();
  const handleDelSession = () => {
    dispatch(deleteChat(editInfo))
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent w="420px" bg="#fff">
          <ModalHeader color="#27314D" fontSize={"18px"}>
            永久删除会话
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <Box fontSize={"14px"} color="#27314D">
              本条会话数据将被永久删除，不可恢复及撤销。确定要删除吗？
            </Box>
            <Flex mt="40px" justifyContent={"flex-end"}>
              <Button
                w="76px"
                h="37px"
                mr="15px"
                bg="#CBD1DF"
                color={"#27314D"}
                fontSize="12px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{
                  bg: "#CBD1DF",
                  color: "#8E94A9",
                }}
                onClick={() => onClose()}
              >
                取消
              </Button>
              <Button
                w="76px"
                h="37px"
                bg="#496AE1"
                color={"#FFFFFF"}
                fontSize="12px"
                fontWeight={"normal"}
                borderRadius={0}
                _hover={{
                  bg: "#3F5BC1",
                  color: "#E6E6E6",
                }}
                onClick={handleDelSession}
              >
                完成
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
  );
};

export default DelModal;